import { Component, OnInit } from '@angular/core';
import { Catalog } from 'app/Model/Catalog/Catalog';
import { UrlImportJobSettings } from 'app/Model/recurringJobs/urlImportJobSettings';
import { Message } from 'app/Model/System/Message';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { FtpImportJobService } from 'app/Services/ftp/ftpImportJob.service';
import { FtpServerService } from 'app/Services/ftp/ftpServer.service';
import { LoginService } from 'app/Services/login.service';
import { SystemService } from 'app/Services/system.service';
import { TemplateService } from 'app/Services/template.service';
import { UrlImportJobSettingsService } from 'app/Services/urlImportJobSettingsService';
import {RowInsertedEvent, RowUpdatedEvent, RowRemovedEvent, InitNewRowEvent} from 'devextreme/ui/data_grid';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'urlimport',
  templateUrl: './urlimport.component.html',
  styleUrl: './urlimport.component.css'
})
export class UrlimportComponent implements OnInit {
  catalogs: Catalog[] = [];
    dataSource: UrlImportJobSettings[] = [];

  constructor(
    public templateService: TemplateService,
    public catalogService: CatalogService,
    public loginService: LoginService,
    public urlImportJobSettingsService :UrlImportJobSettingsService,
    public systemService : SystemService
  ) {
    this.catalogService.getCatalogs(this.loginService.currentCustomer.id).subscribe((catalogs: Catalog[]) => {
      this.catalogs = catalogs;
    });
  }

    async ngOnInit(): Promise<void> {
      this.dataSource = await this.urlImportJobSettingsService.getAll(this.loginService.currentCustomer.id)
        .then((data: UrlImportJobSettings[]) => {
          data.forEach((f: UrlImportJobSettings) => {
            f.time = new Date(f.time);
          });
          return data;
        });
    }

  async onRowInserted(event: RowInsertedEvent<UrlImportJobSettings>) {
    await this.urlImportJobSettingsService.create(event.data, this.loginService.currentCustomer.id);
  }

  async onInitNewRow(event: InitNewRowEvent<UrlImportJobSettings>) {
    event.data.active = true;
  }

  async updateActiveStatus(event: any, data: any) {

    if (event.value == event.previousValue) {
      return;
    }
    if (event.value == true) {
      data.timesFailed = 0;
    }
    await this.urlImportJobSettingsService.update(data, this.loginService.currentCustomer.id);
  }

  async onRowUpdated(event: RowUpdatedEvent<UrlImportJobSettings>) {
    await this.urlImportJobSettingsService.update(event.data, this.loginService.currentCustomer.id);
  }

  async onRowRemoved(event: RowRemovedEvent<UrlImportJobSettings>) {
    await this.urlImportJobSettingsService.delete(event.data.id, this.loginService.currentCustomer.id);
  }
  
  isManager(): boolean {
    if (this.loginService.currentUser.currentClaim == "MANAGER" || this.loginService.currentUser.currentClaim == "ADMIN")
      return true;
    return false;
  }

  getTime(rowData): string {
    if (rowData.time instanceof String)
      rowData.time = new Date(rowData.time);

    return rowData.time;
  }

  getLastRun(rowData): string {
    if (rowData.lastRun instanceof String)
      rowData.lastRun = new Date(rowData.lastRun);

    return rowData.lastRun;
  }

    run(d) {
      this.urlImportJobSettingsService.run(d.data.id, this.loginService.currentCustomer.id).subscribe(() => {
        this.systemService.notify(new Message("Job wurde manuell gestartet"));
      }, error => {
        let msg = new Message();
        msg.type = "Error";
        msg.message = "Fehler beim manuellen starten";
        this.systemService.notify(msg);
      });
    }
}
